<ng-container>
  <form
    nz-form
    [formGroup]="forgotPasswordForm"
    class="forgot-password-form"
    (ngSubmit)="submitForm()"
  >
    <nz-form-item>
      <nz-form-control [nzErrorTip]="emailErrorTpl">
        <nz-input-group [nzPrefix]="emailPrefixTemplate">
          <input
            type="text"
            nz-input
            formControlName="email"
            [placeholder]="'FORM.LABEL.EMAIL' | translate"
          />
        </nz-input-group>
        <ng-template #emailPrefixTemplate>
          <i class="fal fa-envelope"></i>
        </ng-template>
        <ng-template #emailErrorTpl let-control>
          <ng-container *ngIf="control.hasError('email')">
            {{ "FORM.ERR.VALID_EMAIL" | translate }}
          </ng-container>
          <ng-container *ngIf="control.hasError('required')"
            >{{ "FORM.ERR.REQUIRED_EMAIL" | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-control>
        <button
          [nzLoading]="isSubmitting"
          [disabled]="!forgotPasswordForm.valid"
          nz-button
          class="forgot-password-form-button"
          [nzType]="'primary'"
        >
          {{ "PAGE.AUTH.FORGOT_PASSWORD.SUBMIT" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-container>
